import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useConfig } from './use-config';
import { connectDatabaseConnection } from 'services/database-connection-service';

/**
 * Hook to connect (activate) a database connection
 */
export const useConnectDatabaseConnection = () => {
    const { configurationSettings } = useConfig();
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: ({ connectionId, scope }: { connectionId: string; scope: 'user' | 'organization' }) => 
            connectDatabaseConnection(configurationSettings, connectionId, scope),
        onSuccess: () => {
            // Invalidate the database connections list to refresh the data
            queryClient.invalidateQueries({ queryKey: ['listDatabaseConnections'] });
        },
    });
};

